module.exports = __webpack_public_path__ + "static/media/logo.667b5c23.jpg";